import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import about_company from '@/components/about_company'
import about_media from '@/components/about_media'
import cooperation from '@/components/cooperation'
import recruitment from '@/components/recruitment'
import experience from '@/components/experience'
import media_content from '@/components/media_content'
import privacy from '@/components/privacy'
import terms from '@/components/terms'
import support from '@/components/support'
import terms_en from '@/components/terms_en'
import privacy_en from '@/components/privacy_en'
import chu_ti from '@/components/chu_ti'
import chu_ti_ban_quan from '@/components/chu_ti_ban_quan'
import cp_info from '@/components/cp_info.vue'


Vue.use(Router);

export default new Router({
  routes: [
    { path:'/',name:'home',component:index},
    { path: '/index',name:'index', component: index},
    {
        path: '/about',
        name:'about',
        component: about,
        children:[
            {
                path:'',
                name:'about_home',
                component:about_company,
            },
            {
                path:'company',
                name:'company',
                component:about_company,
            },
            {
                path:'media',
                name:'media',
                component:about_media,
            },
            {
                path:'cooperation',
                name:'cooperation',
                component:cooperation,
                redirect: '/cooperation'
            },
            {
                path:'mediaContent',
                name:'mediaContent',
                component:media_content
            }
        ]
    },
    { path: '/privacy_en', component: privacy_en },
    { path: '/terms_en', component: terms_en },
    { path: '/support', component: support },
    { path: '/experience', component: experience },
    { path: '/recruitment', component: recruitment },
    {path: '/cooperation', name:'cooperation',component: cooperation},
    {path: '/privacy', name:'privacy',component: privacy},
    {path: '/terms', name:'terms',component: terms},
    {path: '/chu_ti',  component: chu_ti},
    {path: '/chu_ti_ban_quan',  component: chu_ti_ban_quan},
    {path: '/cp_info',  component: cp_info},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js